
<template>
    <div class="registerWrapper">
        <v-card
            class="elevation-24 register-card-wrapper"
            dark
            shaped
        >
            <div class="registerForm">
                <div
                    style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    "
                >
                    <v-icon
                        class="regIcon"
                        color="white"
                        size="160"
                        style="width: 160px;"
                    >
                        {{ mdiAccount }}
                    </v-icon>
                </div>
                <h2 class="font-weight-black">
                    Member Sign Up
                </h2>
                <div style="position: relative; z-index: 5;">
                    <v-alert
                        v-model="isErrFound.status"
                        class="text-center"
                        transition="scale-transition"
                        color="#ff5252"
                        type="error"
                        prominent
                        dismissible
                        style="position: absolute; background-color: #ff5252; opacity: 1 !important;"
                    >
                        {{ isErrFound.message }}
                    </v-alert>
                </div>
                <v-scroll-x-reverse-transition hide-on-leave>
                    <!-- Dispaly Member Name  -->
                    <div
                        v-if="dispName"
                        class="displayResultInputData"
                    >
                        <div v-if="displayAccountName">
                            <v-text-field
                                v-model="displayAccountName"
                                label="Member Name"
                                color="green"
                                class="thick-loading"
                                :loading="loading.three ? '#4caf50' : false"
                                :prepend-inner-icon="mdiAccount"
                                readonly
                                autocomplete="nope"
                            />
                        </div>
                        <!-- Radio button for name confirmation -->
                        <div>
                            <p
                                class="font-weight-black"
                                style="text-align: center;"
                            >
                                Is this your name?
                            </p>
                            <v-radio-group
                                row
                                class="text-center"
                            >
                                <!-- YES RADIO BUTTON -->
                                <v-radio
                                    v-model="answer"
                                    style="margin: 0 15px 0 auto"
                                    label="Yes"
                                    color="teal"
                                    @change="handleValidationThree"
                                />
                                <!-- NO RADIO BUTTON -->
                                <v-radio
                                    style="margin: 0 auto 0 15px"
                                    label="No"
                                    color="teal"
                                    @change="noDialog = !noDialog"
                                />
                                <!-- END CHOICES -->
                            </v-radio-group>
                        </div>
                    </div>
                </v-scroll-x-reverse-transition>
                <v-scroll-x-transition hide-on-leave>
                    <v-form
                        v-if="!dispName"
                        ref="form"
                        class="inputData"
                        @submit.prevent="handleSubmitForm"
                    >
                        <div class="membcode">
                            <v-text-field
                                ref="memberNumber"
                                v-model="membCode"
                                v-mask="membCodemask"
                                label="Member Code"
                                color="green"
                                :prepend-inner-icon="mdiAccount"
                                :rules="membCodeRule"
                                :loading="loading.two ? '#4caf50' : false"
                                class="thick-loading"
                                autocomplete="nope"
                                @focus="setFocusFunc('memberNumber')"
                            />
                        </div>
                        <!-- User Birthdate -->
                        <div class="bday">
                            <div :style="`color: ${isBirthdateValid ? 'white' : '#ff5252' }; font-weight: 500;`">
                                <v-icon :color="`${isBirthdateValid ? 'white' : '#ff5252' }`">
                                    {{ mdiCalendar }}
                                </v-icon>
                                Birthdate
                                <div v-if="!isBirthdateValid" class="v-text-field__details">
                                    <div class="v-messages theme--dark error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">
                                                This field is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span v-else style="width: 100%; display: block; height: 14px">&nbsp;</span>
                            </div>
                            <v-row>
                                <v-col cols="5">
                                    <v-autocomplete
                                        ref="month"
                                        v-model="bdayTemplate.month"
                                        label="Month"
                                        :items="bdayItemSelection.month"
                                        item-text="text"
                                        item-value="value"
                                        :rules="[v=>!!v||'']"
                                        :loading="loading.two ? '#4caf50' : false"
                                        class="thick-loading"
                                        @focus="setFocusFunc('month')"
                                        @update:search-input="showInput($event, 'month')"
                                        @keydown.enter="handleEnterKey($event, 'month')"
                                        @keydown.tab="handleEnterKey($event, 'month')"
                                        @change="handleBlurBirthdate('month')"
                                        @blur="handleBlurBirthdate('month')"
                                    />
                                </v-col>
                                <v-col cols="3">
                                    <v-autocomplete
                                        ref="day"
                                        v-model="bdayTemplate.day"
                                        label="Day"
                                        :items="bdayItemSelection.day"
                                        :rules="[v=>!!v||'']"
                                        :loading="loading.two ? '#4caf50' : false"
                                        class="thick-loading"
                                        @focus="setFocusFunc('day')"
                                        @update:search-input="showInput($event, 'day')"
                                        @keydown.enter="handleEnterKey($event, 'day')"
                                        @keydown.tab="handleEnterKey($event, 'day')"
                                        @change="handleBlurBirthdate('day')"
                                        @blur="handleBlurBirthdate('day')"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-autocomplete
                                        ref="year"
                                        v-model="bdayTemplate.year"
                                        label="Year"
                                        :items="bdayItemSelection.year"
                                        :rules="[v=>!!v||'']"
                                        :loading="loading.two ? '#4caf50' : false"
                                        class="thick-loading"
                                        @focus="setFocusFunc('year')"
                                        @update:search-input="showInput($event, 'year')"
                                        @keydown.enter="handleEnterKey($event, 'year')"
                                        @keydown.tab="handleEnterKey($event, 'year')"
                                        @change="handleBlurBirthdate('year')"
                                        @blur="handleBlurBirthdate('year')"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                        <div style="margin: 0 auto; width: 300px;">
                            <vue-recaptcha
                                id="register-account"
                                ref="RegisterRecaptchaRef"
                                sitekey="6LfoFcYZAAAAADjyyS2cTbKM1ClbgZDImPrIjdxd"
                                theme="dark"
                                load-recaptcha-script
                                @verify="onCaptchaVerify"
                            />
                            <p class="red--text" style="font-size:15px;">
                                {{ captchaErr ? captchaErr : '' }}
                            </p>
                        </div>
                        <v-btn
                            color="green accent-4"
                            height="55px"
                            class="white--text regValidateBtn"
                            rounded
                            type="submit"
                            :disabled="loading.two"
                            @mouseenter="blurFieldsFunc"
                        >
                            Validate
                        </v-btn>
                        <errCaptcha
                            :show-err-diag="true"
                            :result-data="showCaptchaErr"
                            @errorInput="errorInput"
                        />
                    </v-form>
                </v-scroll-x-transition>
            </div>
            <!-- END FORM -->
            <!-- ================================== -->
            <!-- DIALOG BOXES -->
            <!-- ================================== -->
            <dlg_accountInactive
                :status-dialog="statusDialog"
                :status="getValidationTwo"
                @pop-statusDialog="statusInactiveDialog"
            />
            <dlg_signupErr
                :sign-up-err-dialog="signUpErrDialog"
                :result-data="getValidationOne"
                @pop-signUpErrDialog="ErrDialog"
            />
            <!--if 0 = Account does not exist -->
            <!-- YES: Account doesnt exist and Create account form = show -->
            <dlg_YesAccountDoesntExist
                v-if="getYesDialogModifier == 0"
                :doesnt-exist="accountDoesntExist"
                :result-data="getValidationThree"
                :create-account-form="createAccountForm"
                @pop-yesDoesntExist="yesDialogDoesntExist"
            />
            <!--if 1 = Account does exist -->
            <!-- YES: Account exist -->
            <dlg_YesAccountDoesExist
                v-else
                :yes-dialog-does-exist="accountDoesExist"
                :result-data="getValidationThree"
                @pop-yesDialog="yesDialogDoesExist"
            />
            <!-- WHEN USER SELECTS "NO" RADIO BUTTON -->
            <dlg_NotAccount
                v-if="noDialog"
                :no-dialog="noDialog"
                @pop-noDialog="notAccount"
            />
            <div class="my-3 text-center">
                Already have an account? <span @click="toSignUp(registerForm)">Login here</span>
            </div>
            <!-- wrapper -->
        </v-card>
    </div>
</template>

<script>
import { moment } from '../../utils/date-shim'
import dlg_YesAccountDoesntExist from './DialogBoxes/dlg_YesAccountDoesntExist.vue'
import dlg_YesAccountDoesExist from './DialogBoxes/dlg_YesAccountDoesExist.vue'
import dlg_NotAccount from './DialogBoxes/dlg_NotAccount.vue'
import dlg_signupErr from './DialogBoxes/dlg_signupErr.vue'
import dlg_accountInactive from './DialogBoxes/dlg_accountInactive.vue'
import { mapActions, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'
import VueRecaptcha from 'vue-recaptcha'
import errCaptcha from './DialogBoxes/dlg_errCpatcha.vue'
import { mdiAccount, mdiCalendar } from '@mdi/js'
export default {
    components: { dlg_YesAccountDoesntExist, dlg_YesAccountDoesExist, dlg_NotAccount, dlg_signupErr, dlg_accountInactive, VueRecaptcha, errCaptcha },
    directives: {
        mask
    },
    props: ['createAccountForm', 'registerForm'],
    data: () => ({
        mdiAccount, mdiCalendar,
        loading: {
            two: false,
            three: false
        },
        setFocusVar: null,
        isBlurAndValidBirthdate: {
            month: false,
            day: false,
            year: false
        },
        bdayTemplate: {
            month: null,
            day: null,
            year: null
        },
        bdayInput: {
            month: null,
            day: null,
            year: null
        },
        bdayItemSelection: {
            month: [
                { text: 'January', value: 1 },
                { text: 'February', value: 2 },
                { text: 'March', value: 3 },
                { text: 'April', value: 4 },
                { text: 'May', value: 5 },
                { text: 'June', value: 6 },
                { text: 'July', value: 7 },
                { text: 'August', value: 8 },
                { text: 'September', value: 9 },
                { text: 'October', value: 10 },
                { text: 'November', value: 11 },
                { text: 'December', value: 12 }
            ],
            day: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
            year: []
        },
        isErrFound: {
            status: false,
            message: ''
        },
        showSignup: false,
        membCodeRule: [(v) => !!v || 'This field is required'],
        bdayRule: [(v) => !!v || ''],
        valid: true,
        switch1: true,
        bDayMask: '####-##-##',
        bDay: null,
        menu: false,
        membCodemask: '######',
        membCode: '',
        membName: null,
        answer: 'yes',
        accountDoesntExist: false,
        accountDoesExist: false,
        noDialog: false,
        signUpErrDialog: false,
        statusDialog: false,
        resData: '',
        status: '',
        captchaToken: null
    }),
    computed: {
        ...mapGetters(['getValidationOne', 'getValidationTwo', 'getValidationThree', 'displayAccountName', 'getYesDialogModifier', 'getStatus', 'captchaErr']),
        isBirthdateValid() {
            if (this.isBlurAndValidBirthdate.month && !this.isMonthValid()) return false
            if (this.isBlurAndValidBirthdate.day && !this.isDayValid()) return false
            if (this.isBlurAndValidBirthdate.year && !this.isYearValid()) return false
            return true
        },
        dispName() {
            return this.displayAccountName !== undefined && this.displayAccountName !== null && String(this.displayAccountName).trim().length > 0
        },
        showCaptchaErr: {
            get() {
                try {
                    if (String(this.captchaErr).trim() !== '') {
                        return this.captchaErr
                    } else {
                        return ''
                    }
                } catch {
                    return false
                }

            }
        }
    },
    watch: {
        getYesDialogModifier(newVal) {
            if (newVal == 1) {
                this.accountDoesExist = !this.accountDoesExist
            } else {
                this.accountDoesntExist = !this.accountDoesntExist
            }
        },
        getStatus(newVal) {
            if (newVal && newVal.status === 403) {
                this.isErrFound.status = true
                this.isErrFound.message = newVal.state
            }
            setTimeout(()=>{
                this.isErrFound.status = false
                this.isErrFound.message = ''
            }, 10000)
        }
    },
    created() {
        const currentYear = moment().year()
        for (let i=currentYear; i>1899; i--) {
            this.bdayItemSelection.year.push(i)
        }
    },
    methods: {
        // START ACTION METHODS
        ...mapActions(['validationOneTwo', 'validationThree', 'toSignupLogin', 'getCsrfToken']),
        handleValidationThree() {
            this.loading.three = true
            this.validationThree({ MEMBCODE: this.membCode, ANSWER: this.answer })
        },
        blurFieldsFunc() {
            if (this.$refs && this.$refs[this.setFocusVar]) {
                if (this.setFocusVar !== 'memberNumber') {
                    this.handleEnterKey(false, this.setFocusVar)
                } else {
                    this.$refs.memberNumber.blur()
                }
            }
        },
        setFocusFunc(field) {
            this.setFocusVar = field
        },
        showInput(e, field) {
            this.bdayInput[field] = e ? e : null
        },
        handleEnterKey(e, field) {
            if (e) e.preventDefault()
            if (field === 'month') {
                this.bdayTemplate.month = this.bdayItemSelection.month.find(item =>
                    item.text.toLowerCase().startsWith(this.bdayInput.month.toLowerCase())
                ).value
            } else if (field === 'day') {
                this.bdayTemplate.day = this.bdayItemSelection.day.find(day => day === Number(this.bdayInput.day))
            } else if (field === 'year') {
                this.bdayTemplate.year = this.bdayItemSelection.year.find(day => day === Number(this.bdayInput.year))
            }
            if (e && e.key === 'Tab') {
                this.$nextTick(() => {
                    if (field === 'month') {
                        this.$refs.day.focus()
                    } else if (field === 'day') {
                        this.$refs.year.focus()
                    }
                })
            } else {
                this.$refs[field].blur()
            }
        },
        isMonthValid() {
            const field = this.$refs.month
            if (!field) return false
            return field.hasError === false
        },
        isDayValid() {
            const field = this.$refs.day
            if (!field) return false
            return  field.hasError === false
        },
        isYearValid() {
            const field = this.$refs.year
            if (!field) return false
            return field.hasError === false
        },
        handleBlurBirthdate(field) {
            if (field === 'month') {
                this.isBlurAndValidBirthdate.month = true
                this.isMonthValid()
            } else if (field === 'day') {
                this.isBlurAndValidBirthdate.day = true
                this.isDayValid()
            } else if (field === 'year') {
                this.isBlurAndValidBirthdate.year = true
                this.isYearValid()
            }
        },
        async handleSubmitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.loading.two = true
                const yyyy = String(this.bdayTemplate.year).padStart(2, '0')
                const mm = String(this.bdayTemplate.month).padStart(2, '0')
                const dd = String(this.bdayTemplate.day).padStart(2, '0')
                this.bDay = `${yyyy}-${mm}-${dd}`
                await this.validationOneTwo({
                    MEMBCODE: this.membCode,
                    BDAY: this.bDay,
                    CAPTCHA: this.captchaToken
                })
                this.signUpErrDialog = !this.signUpErrDialog
                this.loading.two = false
            }
        },
        // For Dialog boxes to avoid mutating a prop
        statusInactiveDialog(statusDialog) {
            this.statusDialog = statusDialog
            this.$store.commit('RESET_VAL_ONE_TWO', '')
            this.$store.commit('RESET_VALIDATION_THREE', '')
        },
        resultData(resultData) {
            this.resData = resultData
            this.$store.commit('RESET_VAL_ONE_TWO', '')
            this.$store.commit('RESET_VALIDATION_THREE', '')
        },
        yesDialogDoesntExist(yesDialog) {
            this.accountDoesntExist = yesDialog
        // this.$store.commit("RESET_VAL_ONE_TWO", "");
        // this.$store.commit("RESET_VALIDATION_THREE", "");
        },
        yesDialogDoesExist(yesDialog) {
            this.accountDoesExist = yesDialog
            this.$store.commit('RESET_VAL_ONE_TWO', '')
            this.$store.commit('RESET_VALIDATION_THREE', '')
        },
        notAccount(noDialog) {
            this.noDialog = noDialog
            this.$store.commit('RESET_VAL_ONE_TWO', '')
            this.$store.commit('RESET_VALIDATION_THREE', '')
        },
        ErrDialog(signUpErrDialog) {
            this.signUpErrDialog = signUpErrDialog
            this.$store.commit('RESET_VAL_ONE_TWO', '')
            this.$store.commit('RESET_VALIDATION_THREE', '')
        },
        toSignUp(registerForm) {
            this.toSignupLogin(registerForm)
            this.$store.state.accntName = ''
        },
        errorInput(param) {
            this.loading = false
            if (this.$refs) {
                if (this.$refs.RegisterRecaptchaRef) this.$refs.RegisterRecaptchaRef.reset()
            }
            this.$store.commit('SET_ERROR_MESSAGE', param)
        },
        onCaptchaVerify(token) {
            this.captchaToken = token
        }
    }
}
  </script>

  <style scoped>
  /* input[type="date"]::-webkit-calendar-picker-indicator {
    color: rgba(0, 0, 0, 0);
    opacity: 1;
    display: block;
    background: '📅';
    background-color: white;
    border-radius: 13px;
    padding: -5px;
    width: 30px;
    height: 30px;
    border-width: thin;
  } */
  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    width: 0;
    height: 0;
  }
  /* CARD Component */
  .register-card-wrapper {
    margin: 0 auto;
    width: 87%;
    height: 546px;
    /* background-image: linear-gradient(70deg, #43e97b 0%, #38f9d7 100%); */
  }
  .registerContentWrapper {
    background-color: transparent;
    margin: auto;
  }
  .registerForm {
    /* background-color: blue; */
    width: 90%;
    margin: 0 auto;
  }
    .regIcon {
      width: 100%;
      margin: 0 auto;
      /* background-color: red; */
    }
    .registerForm h2 {
      /* background-color: green; */
      text-align: center;
    }
    .inputData {
      /* background-color: blue; */
      margin-top: 30px;
      padding: 0 10px;
    }
    .displayResultInputData {
      margin: 46.5px auto;
      width: 85%;
      /* background-color: red; */
    }
  .regValidateBtn {
    width: 87%;
    margin: 20px auto 0 auto;
    display: block;
  }
  /* Text fields */
  .membcode, .bday {
    width: 85%;
    margin: 0 auto;
    color: white;
  }
  /* Radio button */
  .radioBtns {
    opacity: 0;
    pointer-events: none;
  }
  span {
    cursor: pointer;
    font-weight: bold;
    color: white;
  }
  @media (max-width: 599px) {
    .register-card-wrapper {
      height: 610px;
      width: 90%;
    }
    .registerContentWrapper {
      height: 100%;
      width: 90%;
    }
  }
  @media (min-width: 599px) and (max-width: 960px) {
    .register-card-wrapper {
      height: 610px;
      width: 60%;
    }
    .registerContentWrapper {
      height: 100%;
      width: 90%;
    }
  }
  @media (min-width: 960px) and (max-width: 1264px) {
    .register-card-wrapper {
      height: 610px;
      width: 40%;
    }
    .registerContentWrapper {
      height: 100%;
      width: 80%;
    }
  }
  @media (min-width: 1264px) and (max-width: 1904px) {
    .register-card-wrapper {
      height: 610px;
      width: 30%;
    }
    .registerContentWrapper {
      height: 100%;
      width: 80%;
    }
  }
  @media (min-width: 1904px) {
    .register-card-wrapper {
      width: 20%;
      height: 610px;
    }
    .login-card-wrapper {
      width: 20%;
      /* height: 800px; */
    }
  }
  ::v-deep .thick-loading .v-progress-linear {
    height: 6px !important;
  }
  </style>
